(function ($, document) {
	'use strict';

	$(document).ready(function () {
		$('.product-category-content__inner--smaller').each(function () {
			var termDescription = $(this);
			var termParent = $(this).parent();

            console.log(termDescription);
            console.log(termParent);

			$(termParent).on('click', 'button', function (ev) {
				ev.preventDefault();

				termDescription.toggleClass('product-category-content__inner--smaller');
				$(this).toggleClass('read-more--nudged');

				if ($(this).text() === 'Read more') {
					$(this).text('Read less');
				} else if ($(this).text() === 'Read less') {
					$(this).text('Read more');

					// Scroll to keep your position when you close.
					$([document.documentElement, document.body]).animate({
						scrollTop: termParent.offset().top
					}, 500);
				}
			});

			var button = '<button class="read-more">Read more</button>';
			$(button).insertAfter(termDescription);
		});
	});

})(jQuery, document);
